import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { fetchCart } from "../../../../_actions/cart.actions";
import { FaCartPlus } from "react-icons/fa";

export const CartPreview = () => {
  const dispatch = useDispatch();
  const { CartItemsList, cartItems, CartItemsID, comeFromRoute } = useSelector((state) => state.cart);
  const { loggedIn } = useSelector((state) => state.authentication);

  useEffect(() => {
    if (loggedIn && comeFromRoute !== "CART") {
      dispatch(fetchCart());
    }
  }, [loggedIn, dispatch, comeFromRoute]);

  const getCartCount = () => {
    if (CartItemsID) {
      return CartItemsList.length > 0 ? CartItemsList.length - 1 : 0;
    } else {
      return !loggedIn ? CartItemsList.length : cartItems.length;
    }
  };

  const count = getCartCount();

  return (
    <Link to="/cart" className="relative p-2 rounded-full hover:bg-slate-50 transition-all text-slate-700 hover:text-blue-600 block select-none border border-slate-100 hover:border-slate-200 shadow-sm active:scale-95">
      <FaCartPlus className="w-4.5 h-4.5" />
      <span className="absolute -top-1.5 -right-1.5 bg-red-500 text-white font-extrabold text-[9px] w-4.5 h-4.5 rounded-full flex items-center justify-center border-2 border-white shadow-sm">
        {count}
      </span>
    </Link>
  );
};
